(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aud-coleccion"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* LA BARRA SE ENCOGE CUANDO SE PEGA.
     CSS no sabe todavía si un `position: sticky` está pegado o suelto —`:stuck` no existe en
     ningún navegador de producción—, así que hace falta avisarlo. Se hace con un centinela de
     altura cero justo encima de la barra: cuando ese centinela sale del recuadro que empieza
     bajo el encabezado, la barra ya está pegada. Es un IntersectionObserver, no un escuchador
     de scroll: no corre código en cada píxel que se desliza.
     El margen del recuadro se lee del `top` que la barra tenga puesto, así que si algún día
     cambia la altura del encabezado esto lo sigue solo. */
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const barra = document.querySelector('.aud-barra');
      const centinela = document.querySelector('.aud-barra__centinela');
      if (!barra || !centinela || barra.classList.contains('aud-barra--suelta')) return;

      let vigia = null;
      const montar = () => {
        vigia?.disconnect();
        const tope = Math.round(parseFloat(getComputedStyle(barra).top)) || 0;
        vigia = new IntersectionObserver(
          ([entrada]) => barra.classList.toggle('is-pegada', entrada.intersectionRatio === 0),
          { rootMargin: `-${tope + 1}px 0px 0px 0px`, threshold: [0, 1] }
        );
        vigia.observe(centinela);
      };

      montar();
      window.addEventListener('resize', montar, { passive: true });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
